<template>
				
	<!-- Projects Table Card -->
	<a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0,}">
		<template #title>
			<a-row type="flex" align="middle">
				<a-col :span="24" :md="12">
					<h6>{{ title }}</h6>			
					<p>
                        {{ description }} 
                        <!-- <span class="text-primary">{{ dataCount }}</span>  -->
                    </p>	
				</a-col>
			</a-row>
		</template>
		<a-table 
            :columns="columns" 
            :data-source="data" 
            :row-key="record => record.id"
            :pagination="pagination"
            :loading="loading"
            @change="onChange"
            >
            <!-- 在仓包裹 -->
			<template slot="source_waybill_no" slot-scope="text, record, index">
                <div class="record_numbers">
                    <template v-if="record.imgs.length">
                        <template v-for="img in record.imgs.slice(0,1)">
                            <img class="photo" v-lazy="img" alt="" @click="onPreview(record)">
                        </template>
                    </template>
                    <template v-else>
                        <div class="default_photo"><a-icon type="picture"></a-icon></div>
                    </template>
                    {{ record.source_waybill_no }}
                </div>
            </template>

            <template slot="pkg_items" slot-scope="text, record, index">
				<div style="width: 120px;white-space: nowrap; text-overflow: ellipsis;overflow: hidden;">
                    <a-tooltip placement="topLeft">
                        <template slot="title">
                        <span>{{ record.pkg_items }}</span>
                        </template>
                        {{ record.pkg_items ? record.pkg_items : '--'}}
                    </a-tooltip>
                    
                </div>
            </template>

            <template slot="weight_volume" slot-scope="text, record">
                {{ record.fee_weight }}{{ $APPCFG.cfg_weight }} / {{ record.lwh_tj }}m³
            </template>
            <template slot="operation1" slot-scope="text, record">
                <div class="link">
                    <a-button type="link" @click="onView1(record.id)">{{ $t('view') }}</a-button>
                    <a-button type="link" @click="onDeclare(record.id)">{{ $t('info_25') }}</a-button>
                </div>
            </template>

            <!-- 出库包裹 -->
            <template slot="trans_num" slot-scope="text, record, index">
                <div class="trans_num" @click="onView2(record.trans_num)">
                    {{ record.trans_num }}
                </div>
            </template>

            <template slot="status" slot-scope="text, record">
                <div style="display: flex;">
                    <div class="steps">
                        <template v-for="i in 4">
                            <div class="dot" :class="{active: (i - 1) == getCurrent(record.status), finished: (i - 1) <= getCurrent(record.status)}"></div>
                        </template>
                    </div>
                    <div>
                        <a-tag class="tag-status tag_other">{{ statusList[getCurrent(record.status)] }}</a-tag>
                    </div>
                </div>
            </template>
            <template slot="operation2" slot-scope="text, record">
                <div class="link"><a-button type="link" @click="onView3(record.order_id)">{{ $t('view') }}</a-button></div>
            </template>
		</a-table>

        <a-modal v-model="showPreview" :footer="null" width="45%">
            <div style="padding: 0 10px;margin: 20px 0;max-height: 600px;overflow-y: auto;">
                <div style="margin-bottom: 10px;border-bottom: 1px solid #eee;" v-for="item in previewImgs">
                    <a target="_blank" :href="item"><img v-lazy="item" style="width: 100%;margin-bottom: 10px;"/></a>
                </div>
            </div>
        </a-modal>

	</a-card>
	<!-- / Projects Table Card -->

</template>

<script>

	export default ({
		props: {
            title: {
                type: String,
                default: ''
            },
			data: {
				type: Array,
				default: () => [],
			},
			columns: {
				type: Array,
				default: () => [],
			},
            dataCount: '',
            loading: {
                type: Boolean,
                default: false,
            },
            description: '',
		},
		data() {
			return {
                pagination: {
                    total: 0,
                    pageSize: 6,
                    size: 'small'
                },

                showPreview: false,
                previewImgs: '',

                statusList: [this.$t('info_27'), this.$t('info_28'), this.$t('info_29'), this.$t('info_30')]
			}
		},
        created() {
            this.pagination.total = this.data.length;
        },

        methods: {
            getCurrent(status) {
                let current = 0;

                if(status <= 2) {
                    current = 0;
                }else if(status > 2 && status <= 6) {
                    current = 1;
                }else if(status > 6 && status <= 10) {
                    current = 2;
                }else {
                    current = 3;
                }

                return current;
            },
            onChange(pagination) {
                // this.$emit('change',pagination.current);
            },

            onPreview(record) {
                this.previewImgs = record.imgs;
                this.showPreview = true;
            },
            onTrack(postnum) {
                this.$router.push('/track?postnum=' + postnum);
            },
            onView1(id){
                this.$router.push('/user/package_forecast/view?id=' + id);
            },
            onView2(trans_num){
                this.$router.push('/user/package/view?trans_num=' + trans_num);
            },
            onView3(id) {
                this.$router.push('/user/order/view?id=' + id);
            },

            onDeclare(id) {
                this.$router.push('/user/package_forecast/edit?id=' + id);
            },
        }
	})

</script>

<style lang="scss" scoped>
    /deep/ .ant-pagination {
        padding: 0 15px;
    }
    .trans_num {
        color: #0565a9;
        text-decoration: underline;
        cursor: pointer;
    }
    .record_numbers {
        display: flex;
        align-items: center;
        .photo {
            width: 24px;
            height: 24px;
            border-radius: 4px;
            margin-right: 5px;
            object-fit: cover;
            cursor: pointer;
        }
        .default_photo {
            width: 24px;
            height: 24px;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #f0f2f5;
            margin-right: 5px;
            font-size: 12px;
            color: #8C8C8C;
        }
    }
    .link {
        line-height: normal;
        display: flex;
        /deep/ .ant-btn {
            line-height: normal;
            padding: 0 6px;
            height: 18px;
            padding-left: 0;
            font-weight: normal;
            font-size: 13px;
            span {
                text-decoration: underline;
            }
        }
    }
    .preview_img {
        width: 100%;
    }


    .tag_complete {
        background-color: rgb(248,252,249);
        border-color: rgb(248,252,249);
        color: rgb(82,196,26);
    }
    .tag_other {
        background-color: rgb(248,250,255);
        border-color: rgb(248,250,255);
        color: rgb(24,144,255);
    }

    .steps {
        display: flex;
        align-items: center;
        position: relative;
        overflow: hidden;
        margin-right: 10px;
        &:after {
            content: '';
            left: 0;
            height: 2px;
            width: 100%;
            display: block;
            position: absolute;
            background-color: rgb(1,175,68);
            z-index: 0;
        }
        .dot {
            z-index: 1;
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: #fff;
            box-sizing: border-box;
            border: 2px solid rgb(1,175,68);
            margin-right: 20px;
            &.active {
                width: 14px;
                height: 14px;
                background-color: rgb(1,175,68);
            }
            &.finished {
                background-color: rgb(1,175,68);
            }
            &:last-child {
                margin-right: 0;
            }
        }
    }
</style>